/**
 * 系统环境相关工具库
 */

/**
 * aid: androiduniversity / iosuniversity
 * appVersion: 0160
 * authorization: xxx..
 * bundleId: cn.coldlake.university
 * channel: 94 / 0
 * clientSys: android / ios
 * deviceId: xxx..
 * deviceName: MI_6X / iPhone XS
 * osVersion: 28 / 13.4.1
 */
let whoami: any = null;

export function getSystemInfo() {
  if (whoami) return whoami;

  const userAgent = navigator && navigator.userAgent;
  whoami = {};

  if (userAgent) {
    const info = userAgent.split('&').reduce((acc: any, item) => {
      const [key, value] = item.split('=');

      if (key) acc[key] = value;

      return acc;
    }, {});

    // APP 内
    if (info.aid || info.bundleId || info.appVersion) {
      whoami = info;
      whoami.isApp = true;
      whoami.isAndroid = info.clientSys === 'android';
      whoami.isIOS = info.clientSys === 'ios';
      whoami.isIpad = info.clientSys === 'ipad';
    } else {
      // APP 外
      const userAgentLower = userAgent.toLowerCase();
      const isQQBrowser = !!userAgentLower.match('mqqbrowser');
      whoami.isQQBrowser = isQQBrowser;
      whoami.isQQ = !isQQBrowser && !!userAgentLower.match('qq');
      whoami.isWeChat = !!userAgentLower.match('micromessenger');
      whoami.isDingTalk = !!userAgentLower.match('dingtalk');
      whoami.isWeiBo = !!userAgentLower.match('weibo');
      whoami.isIOS = !!userAgentLower.match('iphone');
      whoami.isAndroid = !!userAgentLower.match('android');
      whoami.isWke = !!userAgentLower.match('wke');
      whoami.isMac = /macintosh|mac\b/.test(userAgentLower);
      whoami.isWin = !!(
        userAgentLower.match('win32') ||
        userAgentLower.match('win64') ||
        userAgentLower.match('wow32') ||
        userAgentLower.match('wow64')
      );
    }
  } else {
    whoami.error = 'no userAgent';
  }

  return whoami;
}
